import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgZoomOut = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M16.5 6V2.498C16.5 2.23278 16.3946 1.97843 16.2071 1.79089C16.0196 1.60336 15.7652 1.498 15.5 1.498H12",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.9999 16.5H15.5006C15.7658 16.5 16.0202 16.3946 16.2077 16.2071C16.3953 16.0196 16.5006 15.7652 16.5006 15.5V12",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M1.50067 12V15.498C1.50067 15.7633 1.60602 16.0176 1.79356 16.2052C1.9811 16.3927 2.23545 16.498 2.50067 16.498H6",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6 1.498H2.50067C2.23545 1.498 1.9811 1.60336 1.79356 1.79089C1.60602 1.97843 1.50067 2.23278 1.50067 2.498V6",
			stroke: "#8C94AA",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgZoomOut);
export default ForwardRef;
